module.exports = __webpack_public_path__ + "static/media/404.70e270f9.svg";